import React, {createRef, useEffect, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import useResponsive from "../hooks/responsive";


export default function MobileMenuHelper({label}) {
    const [isMenuDeployed, setIsMenuDeployed] = useState(false)
    const ref = createRef()
    const [isMobile, maxWidthConteiner] = useResponsive()

    useEffect(() => {
        if(!isMobile) return

        const newDisplay = isMenuDeployed ? 'grid' : 'none';

        const element = document.getElementById('tool-menu-search')
        if(element) {
            element.style.display = newDisplay
        }

    }, [isMenuDeployed])

    useEffect(() => {
        const l1 = () => setIsMenuDeployed(false)
        document.addEventListener('masterclass_select', l1)

        const l2 = () => setIsMenuDeployed(false)
        document.addEventListener('course_select_video', l2)

        const l3 = () => setIsMenuDeployed(false)
        document.addEventListener('select_university_select', l3)


        return () => {
            document.removeEventListener('masterclass_select', l1)
            document.removeEventListener('course_select_video', l2)
            document.removeEventListener('select_university_select', l3)
        }
    }, [])

    if(!isMobile) return null
    return(
        <Container ref={ref} onClick={() => setIsMenuDeployed(!isMenuDeployed)}>
            {label}
        </Container>
    )
}

const Container = styled.div`
    margin-top: 26px;
    background-color: grey;
    text-align: center;
    pointer: cursor;
    padding: 16px;
    color: black;

    &:hover {
            color: #FA9F63;

    }

    &:active {
            color: #FA9F63;

    }
`


if (document.getElementsByTagName('tool-layout-mobile-helper')) {
    const elms = document.getElementsByTagName('tool-layout-mobile-helper')

    for(let elm of elms) {
        const label = elm.attributes['data-label'].value
        ReactDOM.render(<MobileMenuHelper  label={label} />, elm);
    }
}
